<template>
  <div v-if="getShowDarkModeToggle" :class="prefixCls" @click="toggleDarkMode">
    <section v-if="!getCollapsed" class="btn-box flex justify-between">
      <div class="btn flex items-center py-1 pl-3.5" :class="{ active: isDark }">
        <SvgIcon :name="getMoonIcon" size="20" />
        深色
      </div>
      <div class="btn flex items-center py-1 pr-3.5" :class="{ active: !isDark }">
        <SvgIcon :name="getSunIcon" size="20" class="mr-2" />
        浅色
      </div>
    </section>
    <section v-else class="btn-box-collapse flex justify-between">
      <div class="btn flex items-center p-1" :class="{ active: isDark }">
        <SvgIcon :name="getMoonIcon" size="16" />
      </div>
      <div class="btn flex items-center p-1" :class="{ active: !isDark }">
        <SvgIcon :name="getSunIcon" size="16" class="mr-2" />
      </div>
    </section>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import { SvgIcon } from '/@/components/Icon';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useRootSetting } from '/@/hooks/setting/useRootSetting';
  import { updateHeaderBgColor, updateSidebarBgColor } from '/@/logics/theme/updateBackground';
  import { updateDarkTheme } from '/@/logics/theme/dark';
  import { ThemeEnum } from '/@/enums/appEnum';
  import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';

  const { prefixCls } = useDesign('dark-switch');
  const { getDarkMode, setDarkMode, getShowDarkModeToggle } = useRootSetting();
  const { getCollapsed } = useMenuSetting();
  const isDark = computed(() => getDarkMode.value === ThemeEnum.DARK);

  const getSunIcon = computed(() => (isDark.value ? 'sun_dark' : 'sun'));
  const getMoonIcon = computed(() => (isDark.value ? 'moon_dark' : 'moon'));
  console.log('isDark', isDark);
  function toggleDarkMode() {
    const darkMode = getDarkMode.value === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
    setDarkMode(darkMode);
    updateDarkTheme(darkMode);
    updateHeaderBgColor();
    updateSidebarBgColor();
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-dark-switch';

  .@{prefix-cls} {
    .btn-box {
      background: @bg-color;
      padding: 4px;
      border-radius: 12px;

      .btn.active {
        border-radius: 12px;
        background: @component-bg-color4;
        padding-right: 14px;
        padding-left: 14px;
      }
    }

    .btn-box-collapse {
      width: 56px;
      background: @bg-color;
      padding: 4px;
      border-radius: 12px;
      // 左移动一半
      margin-left: calc(((40px - 56px) / 2));

      .btn.active {
        border-radius: 50%;
        background: @component-bg-color4;
      }
    }
  }
</style>
